<template>
  <div class="lang-switch">
    <a @click="changeLanguage('en')" class="switch" :class="{'active': activeLang === 'en'}">
      En
    </a>
    <a @click="changeLanguage('jp')" class="switch" :class="{'active': activeLang === 'jp'}">
      日本語
    </a>
  </div>
</template>

<script>
  export default {
    name: 'LangSwitch',
    methods: {
      changeLanguage (lang) {
        this.$root.changeLanguage(lang)
      },
    },
    computed: {
      activeLang () {
        return this.$root.lang
      }
    }
  }

</script>

<style scoped>
  .switch {
    display: inline-block;
    padding: 8px;
    text-transform: uppercase;
    opacity: 0.5;
  }

  .switch.active {
    font-weight: 700;
    opacity: 1;
  }
</style>
